import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'project-create-importer-upload-flow.project-create-screen.header',
		defaultMessage: 'Set up a project in Jira',
		description: 'Text for the page header',
	},
	projectName: {
		id: 'project-create-importer-upload-flow.project-create-screen.project-name',
		defaultMessage: 'Project name',
		description: 'Field header for the project name field',
	},
	projectNamePlaceholder: {
		id: 'project-create-importer-upload-flow.project-create-screen.project-name-placeholder',
		defaultMessage: 'Project name',
		description: 'Field placeholder for the project name field',
	},
	projectNameTooLong: {
		id: 'project-create-importer-upload-flow.project-create-screen.project-name-too-long',
		defaultMessage: 'The project name is too long',
		description: 'Project name validation error message',
	},
	projectNameTooShort: {
		id: 'project-create-importer-upload-flow.project-create-screen.project-name-too-short',
		defaultMessage: 'The project name is too short',
		description: 'Project name validation error message',
	},
	projectNameEmpty: {
		id: 'project-create-importer-upload-flow.project-create-screen.project-name-empty',
		defaultMessage: 'Your new project needs a name',
		description: 'Project name validation error message',
	},
	allFieldsRequired: {
		id: 'project-create-importer-upload-flow.project-create-screen.all-fields-required',
		defaultMessage: 'All fields are required',
		description: 'Message to inform user that all fields are required',
	},
});
